import config from '../../config';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import React from 'react';

/*
  Only one solution found for recaptcha is use wrapper
  and children => withGoogleReCaptcha(children)
 */
const GoogleRecaptchaWrapper = ({ children }) => (
  <GoogleReCaptchaProvider reCaptchaKey={config.GOOGLE_RECHAPTCHA_V3}>
    {children}
  </GoogleReCaptchaProvider>
);

export default GoogleRecaptchaWrapper;
